import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/authContext";
import { useTranslation } from "react-i18next";
import MyTeam from "./MyTeam";
import TeamRequests from "./TeamRequests";

const PlayerTeamManager = () => {
  const { user, loading: authLoading } = useAuth();
  const { t } = useTranslation();
  const [hasTeam, setHasTeam] = useState(false);
  const [checkingTeam, setCheckingTeam] = useState(true);

  useEffect(() => {
    const checkUserTeam = () => {
      if (authLoading) {
        return; // Wait for auth to complete
      }

      setCheckingTeam(true);
      
      // Check if user has a team assigned
      const userHasTeam = Boolean(user?.metaData?.team);
      
      console.log("PlayerTeamManager - User team check:", {
        user: user ? "exists" : "null",
        metaData: user?.metaData ? "exists" : "null",
        team: user?.metaData?.team || "none",
        hasTeam: userHasTeam
      });
      
      setHasTeam(userHasTeam);
      setCheckingTeam(false);
    };

    checkUserTeam();
  }, [user, authLoading]);

  // Show loading state while checking
  if (authLoading || checkingTeam) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            <div className="px-6 py-4" style={{background: 'linear-gradient(to right, #E26735, #D45420)'}}>
              <h2 className="text-xl font-bold text-white text-center">
                {t("common.loading")}
              </h2>
            </div>
            <div className="p-8 text-center">
              <svg className="animate-spin h-8 w-8 text-orange-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <p className="text-gray-600 mt-4">{t("player.checkingTeamStatus")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render appropriate component based on team status
  if (hasTeam) {
    return <MyTeam />;
  } else {
    return <TeamRequests />;
  }
};

export default PlayerTeamManager; 